import { BrowserRouter } from "react-router-dom";

import { Router } from "@components/Router";
import { useApplicationBootstrap } from "@hooks";
import { Providers } from "./Providers";
import { Wrapper } from "./styles";

export const App = () => {
  useApplicationBootstrap();

  return (
    <BrowserRouter>
      <Wrapper>
        <Providers>
          <Router />
        </Providers>
      </Wrapper>
    </BrowserRouter>
  );
};
